<!-- Modern Login Component -->
<div class="login-container">
  <!-- Background Pattern -->
  <div class="background-pattern"></div>
  
  <!-- Main Login Card -->
  <div class="login-card">
    <!-- Header Section -->
    <div class="login-header">
      <div class="logo-section">
        <div class="logo-icon">
          <i class="pi pi-shield"></i>
        </div>
        <h1 class="login-title">Welcome Back</h1>
        <p class="login-subtitle">Sign in to your account to continue</p>
      </div>
    </div>

    <!-- Form Section -->
    <div class="login-form-container">
      <form (ngSubmit)="onSubmit()" [formGroup]="loginForm" class="login-form">
        
        <!-- Username Field -->
        <div class="form-field">
          <label for="username" class="form-label">
            <i class="pi pi-user"></i>
            Username
          </label>
          <div class="input-container">
            <input
              id="username"
              type="text"
              formControlName="username"
              class="modern-input"
              placeholder="Enter your username"
              [class.input-error]="submitted && f['username'].errors"
            />
            <i class="pi pi-user input-icon"></i>
          </div>
          <div *ngIf="submitted && f['username'].errors" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            <span>Username is required</span>
          </div>
        </div>

        <!-- Password Field -->
        <div class="form-field">
          <label for="password" class="form-label">
            <i class="pi pi-lock"></i>
            Password
          </label>
          <div class="input-container">
            <input
              id="password"
              type="password"
              formControlName="password"
              class="modern-input"
              placeholder="Enter your password"
              [class.input-error]="submitted && f['password'].errors"
            />
            <i class="pi pi-lock input-icon"></i>
          </div>
          <div *ngIf="submitted && f['password'].errors" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            <span>Password is required</span>
          </div>
        </div>

        <!-- Forgot Password Link -->
        <div class="forgot-password">
          <a
            class="forgot-link"
            [routerLink]="['/forgot-password']"
          >
            <i class="pi pi-question-circle"></i>
            Forgot your password?
          </a>
        </div>

        <!-- Submit Button -->
        <div class="form-actions">
          <button
            type="submit"
            class="login-button"
            [disabled]="loading"
            [class.loading]="loading"
          >
            <span *ngIf="!loading" class="button-content">
              <i class="pi pi-sign-in"></i>
              Sign In
            </span>
            <span *ngIf="loading" class="button-content">
              <i class="pi pi-spinner pi-spin"></i>
              Signing In...
            </span>
          </button>
        </div>

        <!-- Error Message -->
        <div *ngIf="error" class="error-container">
          <div class="error-alert">
            <i class="pi pi-exclamation-triangle"></i>
            <span>Incorrect username or password</span>
          </div>
        </div>
      </form>
    </div>

    <!-- Footer Section -->
    <div class="login-footer">
      <p class="footer-text">
        <i class="pi pi-shield"></i>
        Secure login powered by Backflow Integration
      </p>
    </div>
  </div>
</div>
